import type { APIMessage, APIReaction } from '@alternativamais/chat-core';

import { avisarErro } from '../../../componentes/Avisos';
import { Icone } from '../../../componentes/Icone';
import { useCliente } from '../../../chat/contexto';
import { EmojiVisual } from '../SeletorEmoji';
import { useCanal } from './contexto';

function chave(reacao: APIReaction) {
  return reacao.emoji.id ?? reacao.emoji.name ?? '';
}

/** Reações da mensagem (pílulas): clicar reage ou tira a sua. */
export function Reacoes({
  mensagem,
  podeReagir,
}: {
  mensagem: APIMessage;
  podeReagir: boolean;
}) {
  const cliente = useCliente();
  const { abrirEmoji } = useCanal();
  const reacoes = mensagem.reactions ?? [];
  if (!reacoes.length) return null;

  const alternar = (reacao: APIReaction) => {
    const emoji = {
      id: reacao.emoji.id,
      name: reacao.emoji.name,
      animated: reacao.emoji.animated,
    };
    const acao = reacao.me
      ? cliente.unreact(mensagem.channel_id, mensagem.id, emoji)
      : cliente.react(mensagem.channel_id, mensagem.id, emoji);
    acao.catch(avisarErro);
  };

  return (
    <div className="flex flex-wrap gap-1.5 pt-1">
      {reacoes.map((reacao) => {
        const nome = reacao.emoji.id
          ? `:${reacao.emoji.name}:`
          : reacao.emoji.name;
        return (
          <button
            key={chave(reacao)}
            type="button"
            aria-pressed={reacao.me}
            aria-label={`Reação ${nome}, ${reacao.count}${reacao.me ? ', inclusive você' : ''}`}
            title={nome ?? undefined}
            disabled={!podeReagir && !reacao.me}
            onClick={() => alternar(reacao)}
            className={`flex h-7 items-center gap-1.5 rounded-lg border px-2 text-sm ${
              reacao.me
                ? 'border-destaque bg-destaque-suave'
                : 'border-borda bg-elevado hover:border-texto-3'
            }`}
          >
            <EmojiVisual emoji={reacao.emoji} tamanho={18} />
            <span
              className={`text-[13px] font-semibold ${
                reacao.me ? 'text-destaque-claro' : 'text-texto-2'
              }`}
            >
              {reacao.count}
            </span>
          </button>
        );
      })}
      {podeReagir && (
        <button
          type="button"
          aria-label="Adicionar reação"
          onClick={(evento) => {
            const caixa = evento.currentTarget.getBoundingClientRect();
            abrirEmoji({ x: caixa.left, y: caixa.bottom + 4 }, (emoji) =>
              cliente
                .react(mensagem.channel_id, mensagem.id, emoji)
                .catch(avisarErro),
            );
          }}
          className="flex h-7 w-[34px] items-center justify-center rounded-lg border border-borda bg-elevado text-texto-3 hover:text-texto"
        >
          <Icone nome="sorriso" tamanho={18} />
        </button>
      )}
    </div>
  );
}
